const SIZES = {
  CREDENTIAL_NAME: 30,
  CREDENTIAL_VALUE: 69,
};

export default SIZES;
